<template>
  <div class="visit-step" :class="{ 'flow-step--readonly': viewOnly }">
    <div class="visit-step__list">
      <div
        :class="{
          'checklist-item-checked': serviceRequest.customerCall,
          'visit-task-card--call': true
        }"
        class="visit-task-card"
      >
        <div class="visit-task-card__icon visit-task-card__icon--call">
          <i class="fas fa-phone" aria-hidden="true" />
        </div>
        <div class="visit-task-card__body">
          <h5 class="visit-task-card__title">Call to customer</h5>
          <p v-if="serviceRequest.users" class="visit-task-card__meta">
            {{ serviceRequest.users.phone }}
          </p>
        </div>
        <div class="visit-task-card__status">
          <span
            v-if="viewOnly"
            class="flow-status-pill"
            :class="
              serviceRequest.customerCall
                ? 'flow-status-pill--done'
                : 'flow-status-pill--pending'
            "
          >
            {{ serviceRequest.customerCall ? "Done" : "Pending" }}
          </span>
          <base-checkbox
            v-else
            v-model="serviceRequest.customerCall"
            :disabled="parseInt(serviceRequest.currentStep) >= 1"
            type="success"
            @change="handleCallEvent()"
          />
        </div>
      </div>

      <div
        :class="{
          'checklist-item-checked': serviceRequest.isSiteVisited,
          'visit-task-card--visit': true
        }"
        class="visit-task-card"
      >
        <div class="visit-task-card__icon visit-task-card__icon--visit">
          <i class="fas fa-map-marker-alt" aria-hidden="true" />
        </div>
        <div class="visit-task-card__body">
          <h5 class="visit-task-card__title">Site visit</h5>
          <p v-if="serviceRequest.users" class="visit-task-card__meta">
            {{ serviceRequest.users.locality }}
          </p>
        </div>
        <div class="visit-task-card__status">
          <span
            v-if="viewOnly"
            class="flow-status-pill"
            :class="
              serviceRequest.isSiteVisited
                ? 'flow-status-pill--done'
                : 'flow-status-pill--pending'
            "
          >
            {{ serviceRequest.isSiteVisited ? "Done" : "Pending" }}
          </span>
          <base-checkbox
            v-else
            v-model="serviceRequest.isSiteVisited"
            :disabled="parseInt(serviceRequest.currentStep) >= 1"
            type="warning"
            @change="handleVisitEvent()"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import serviceRequestFlowViewOnlyMixin from "@/mixins/serviceRequestFlowViewOnlyMixin";

export default {
  mixins: [serviceRequestFlowViewOnlyMixin],
  computed: {
    ...mapState("serviceRequest", ["serviceRequest"])
  },
  async mounted() {
    await this.fetchServiceRequest(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      updateServiceRequestData: "serviceRequest/updateServiceRequestData"
    }),
    handleCallEvent() {
      if (this.viewOnly) return;
      this.updateServiceRequestData({
        serviceRequestId: this.serviceRequest.serviceRequestId,
        customerCall: this.serviceRequest.customerCall
      });
    },
    handleVisitEvent() {
      if (this.viewOnly) return;
      this.updateServiceRequestData({
        serviceRequestId: this.serviceRequest.serviceRequestId,
        isSiteVisited: this.serviceRequest.isSiteVisited
      });
    }
  }
};
</script>
<style scoped>
.visit-step {
  width: 100%;
}
.visit-step__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.visit-task-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.visit-task-card--call {
  border-left: 4px solid #3b82f6;
}
.visit-task-card--visit {
  border-left: 4px solid #22c55e;
}
.visit-task-card__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.visit-task-card__icon--call {
  background: #dbeafe;
  color: #2563eb;
}
.visit-task-card__icon--visit {
  background: #dcfce7;
  color: #16a34a;
}
.visit-task-card__body {
  flex: 1;
  min-width: 0;
}
.visit-task-card__title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.visit-task-card__meta {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
  word-break: break-word;
  line-height: 1.4;
}
.visit-task-card__status {
  flex-shrink: 0;
}
.flow-status-pill {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
}
.flow-status-pill--done {
  background: #d1fae5;
  color: #065f46;
}
.flow-status-pill--pending {
  background: #f3f4f6;
  color: #6b7280;
}
</style>
